import { createContext, useContext, type ReactNode } from 'react';

export type TFormFieldTexts = {
  fieldRequired: string;
};

const DEFAULT_FORM_FIELD_TEXTS: TFormFieldTexts = {
  fieldRequired: 'Field is required',
};

const FormFieldTextsContext = createContext<TFormFieldTexts>(
  DEFAULT_FORM_FIELD_TEXTS,
);

export function FormFieldTextsProvider({
  children,
  texts,
}: {
  children: ReactNode;
  texts: TFormFieldTexts;
}) {
  return (
    <FormFieldTextsContext.Provider value={texts}>
      {children}
    </FormFieldTextsContext.Provider>
  );
}

export function useFormFieldTexts(): TFormFieldTexts {
  return useContext(FormFieldTextsContext);
}
